import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const HeroContent = () => {
  const navigate = useNavigate();
  return (
    <div className="text-center text-white relative z-10 px-6 md:px-32 lg:px-40 max-w-[95vw] mx-auto mt-[-5vh] md:mt-0">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-3xl md:text-4xl lg:text-6xl font-bold mb-6 md:mb-4 leading-tight"
      >
        A trusted, convenient marketplace
        <br className="hidden md:block" />
        {" "}for on-demand services
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="text-xl md:text-3xl lg:text-4xl text-gray-300 mb-8 md:mb-8 leading-relaxed px-4 md:px-0"
      >
        Hire a driver to chauffeur you in your own or rented vehicle
      </motion.p>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4 px-6 md:px-0 mb-24 md:mb-0"
      >
        <button 
          type="button"
          onClick={() => navigate('/client')} 
          className="group relative px-8 py-3.5 md:py-3 overflow-hidden rounded-full transform transition-transform duration-300 hover:scale-105 w-full md:w-auto"
        >
          <span className="relative z-10 text-black font-medium text-lg md:text-base">
            I'm a Client
          </span>
          <div className="absolute inset-0 bg-white" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-all duration-1000" />
          <div className="absolute inset-0 rounded-full border-2 border-white opacity-0 group-hover:opacity-100 transition-all duration-300" />
          <div className="absolute -inset-1 bg-white/30 rounded-full blur opacity-0 group-hover:opacity-100 transition-all duration-500" />
        </button>

        <button 
          type="button"
          onClick={() => navigate('/chauffeur')} 
          className="group relative px-8 py-3.5 md:py-3 overflow-hidden rounded-full transform transition-transform duration-300 hover:scale-105 w-full md:w-auto"
        >
          <span className="relative z-10 text-white font-medium text-lg md:text-base">
            I'm a Service Provider
          </span>
          <div className="absolute inset-0 border-2 border-white rounded-full" />
          <div className="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-all duration-300 rounded-full" />
          <div className="absolute -inset-0.5 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300">
            <div className="absolute inset-0 rounded-full border-2 border-white/50" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-all duration-1000" />
        </button>
      </motion.div>
    </div>
  );
};

export default HeroContent;